import type { CartType } from "@/shared/types/unified-cart.type";

/**
 * Cart type identifiers
 */
export const CART_TYPES = {
  BOUTIQUE: "boutique",
  DEALS: "deals",
  RENTALS: "rentals",
} as const;

/**
 * Human-readable labels for cart types
 */
export const CART_TYPE_LABELS: Record<CartType, string> = {
  boutique: "Boutique",
  deals: "Bons Plans",
  rentals: "Location",
};

/**
 * Local storage key for persisting selected cart type
 */
export const CART_TYPE_STORAGE_KEY = "yeati-active-cart-type";

/**
 * Default cart type when none is selected
 */
export const DEFAULT_CART_TYPE: CartType = "boutique";
